import styled from "styled-components";
import { Switch } from "antd";

const PodSwitch = styled(Switch)``;

export default PodSwitch;

export const SwitchLabel = styled.div``;
